export default { sha: '5b6510c97c8181ae50551f056193a356f52e2187', buildNumber: 'undefined' }
